import { Route } from "@angular/router";

export const ExpensesPaths = {
  List: "overzicht",
  Categories: "categorien",
  Reports: "notas",
  Check: "polsen",
};

export default [
  {
    path: ExpensesPaths.List,
    loadComponent: () =>
      import("./pages/expense-list/expense-list.component").then((c) => c.ExpenseListComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Kosten",
      subscriptionTypes: [1],
    },
  },
  {
    path: "",
    redirectTo: ExpensesPaths.List,
    pathMatch: "full",
  },
  {
    path: "all",
    redirectTo: ExpensesPaths.List,
  },
  {
    path: ExpensesPaths.Categories,
    loadComponent: () =>
      import("./pages/fee-category-list/fee-category-list.component").then(
        (c) => c.FeeCategoryListComponent
      ),
    data: {
      breadcrumb: "Kostencategorieën",
      title: "Kostencategorieën",
      subscriptionTypes: [1],
    },
  },
  {
    path: ExpensesPaths.Reports,
    loadComponent: () =>
      import("./pages/report-list/report-list.component").then((c) => c.ReportListComponent),
    data: {
      breadcrumb: "Kostennota's",
      title: "Kostennota's",
      subscriptionTypes: [1],
    },
  },
  {
    path: ExpensesPaths.Check,
    loadComponent: () =>
      import("./pages/expense-check/expense-check.component").then((c) => c.ExpenseCheckComponent),
    data: {
      breadcrumb: "Polsen naar kosten",
      title: "Polsen naar kosten",
      subscriptionTypes: [1],
    },
  },
] satisfies Route[];
